export const __initiateSurveyForm = (commit) => {
    setTimeout(() => {
            commit('SET_QNA_FEEDBACK_STATUS', true)
    }, 6000);
    //600000
};